import React, { useState, useEffect, useContext } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { BsFillBellFill } from "react-icons/bs";
import { Checkbox, Nav } from 'rsuite';
import { FaFilter } from "react-icons/fa";

import { doLogOut, downloadFileFromS3Bucket } from '../../redux/actions/auth'
import { ReactComponent as SearchIcon } from '../../assets/svg/search-icon.svg'
import SearchComponent from '../SearchComponent'
import { getSearchTerm } from '../../redux/actions/vendor'
import { autoLogOutTimer } from '../../redux/actions/auth'
import { AppContext } from '../../context'
import { colors } from '../../utils/constants/colors';
import { Badge } from 'rsuite';
import NotificationMenu from '../NotificationMenu';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const HeaderComponent = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useStore().getState()
  const {
    user: {
      recentlyVieweSearchdData,
      recentKeywords
    },
    auth: { user: userData }
  } = store

  const {
    clearStates,
    headerNotificationCount,
    oldUnreadNotification,
    getNewUnreadNotification,
    notificationAllCount,
    notificationUnreadCount
  } = useContext(AppContext);
  
  const { auth, sideMenu } = store
  const { isSideMenuExpanded } = sideMenu
  const { user, isLoggedIn } = auth
  
  const defaultSearchRes = {
    suppliers: [],
    contacts: []
  }

  const [showDropDown, setShowDropDown] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [searchModalOpen, setSearchModalOpen] = useState(false)
  const [headerLeftClass, setHeaderLeftClass] = useState('')
  const [active, setActive] = React.useState('all');
  const [showFilter, setShowFilter] = useState(false)
  const [showNotification, setShowNotification] = useState(false)
  const [total, setTotal] = useState({ all: 0, unread: 0, assignedToMe: 0 })
  const [typingTimeout, setTypingTimeout] = useState(0);
  const [searchResults, setSearchResults] = useState(defaultSearchRes);
  const [isLoader, setIsLoader] = useState(false)
  const [profilePic, setProfilePic] = useState(null)
  const [inputText, setInputText] = useState('')
  const [headerNotification, setHeaderNotification] = useState([])
  const [checkboxInput, setCheckboxInput] = useState(false)


  const CustomNav = ({ active, onSelect, total, notificationAllCount, notificationUnreadCount, ...props }) => {
    return (
      <div className='d-flex'>
        <Nav {...props} activeKey={active} onSelect={onSelect} className='custom-nav w-100'>
          <Nav.Item eventKey="all" className='fw-bold ' style={{ padding: 0, textAlign: 'center', width: '100%' }}>ALL  <span>({notificationAllCount ?? 0})</span></Nav.Item>
          <Nav.Item eventKey="unread" className='fw-bold' style={{ padding: 0, textAlign: 'center', width: '100%' }}>Unread  <span>({notificationUnreadCount ?? 0})</span></Nav.Item>
        </Nav>
      </div>
    );
  };

  useEffect(() => {
    dispatch(autoLogOutTimer())
  }, [dispatch])

  const handleOutsideAccountClick = (event) => {
  const toggleAccountBox = document.querySelector(".toggle-account-container");

  if (toggleAccountBox && !toggleAccountBox.contains(event.target)) {
    setShowDropDown(false);
    document.removeEventListener("mousedown", handleOutsideAccountClick);
  }
};

  const handleToggleAccount = () => {
    setShowDropDown(!showDropDown);
    setShowNotification(false);
    const newState = !showDropDown;
    if (newState) {
      document.addEventListener("mousedown", handleOutsideAccountClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideAccountClick);
    }
  }

  const handleSelect = (activeKey) => {
    let filteredNotifications = []
    if (activeKey === "all") {
      getNewUnreadNotification('', false, '', active, checkboxInput)
    } else if (activeKey === "unread") {
      getNewUnreadNotification('', true, '', active, checkboxInput)
    }
    setHeaderNotification(filteredNotifications)
    setActive(activeKey);
  }

  const handleClickSignOut = () => {
    clearStates()
    dispatch(
      doLogOut()
    )
  }

  if (!isLoggedIn) {
    history.push('/login')
  }

  const filters = [
    { name: 'Email', value: 'email' },
    { name: 'Missed Call', value: 'missedCall' },
    { name: 'QA Rejected', value: 'rejected' }
  ]

  const handleSearchInput = (event) => {
    setSearchValue(event.target.value)
  }

  const onSearchModalClose = () => {
    setSearchValue('')
    setSearchModalOpen(false)
    setHeaderLeftClass('')
  }

  const handleSearchInputClick = () => {
    setSearchModalOpen(true)
    setHeaderLeftClass('focused')
  }

  const onRecentKeywordClick = (value) => {
    setSearchValue(value?.keyword)
  }

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    if (searchValue?.trim()) {
      const timeout = setTimeout(() => {
        fetchSearchResults();
      }, 1500);

      setTypingTimeout(timeout);
    } else {
      setSearchResults(defaultSearchRes);
    }
    return () => clearTimeout(typingTimeout);
  }, [searchValue]);

  const fetchSearchResults = () => {
    setIsLoader(true)
    dispatch(getSearchTerm(searchValue?.trim())).then((res) => {
      setIsLoader(false)
      setSearchResults({
        suppliers: res?.data || [],
        contacts: res?.contacts || []
      })
    }).catch((err) => {
      setIsLoader(false)
      setSearchResults(defaultSearchRes)
    })
  };


  const onFilterCategories = (filterItem) => {
    let category = filterItem === 'email' ? 'email' : filterItem === 'voicemail' ? 'voicemail' : filterItem === 'missedCall' ? 'missedCall' : 'rejected'
    getNewUnreadNotification('', active === "unread" ? true : false, category, active, checkboxInput)
  }

  const onReset = () => {
    getNewUnreadNotification('', active === "unread" ? true : false, '', active, checkboxInput)
    setInputText('')
  }

  // (searchTerm = '', unReadFilterApplied = false, filter = '', active, checkedFilter = false)

  const handleOutsideClick = (event) => {
  const notificationBox = document.querySelector(".notification-container-update");

  if (notificationBox && !notificationBox.contains(event.target)) {
    setShowNotification(false);
    document.removeEventListener("mousedown", handleOutsideClick);
  }
};

  const notificationHandler = (e) => {
    e.stopPropagation()
    setShowNotification(!showNotification)
    setShowFilter(false)
    setActive("all")
    const newState = !showNotification;
    if (newState) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
  }

  const redirectHandler = (type) => {
    setShowNotification(false)
    let tmpType = type === 'email' ? 'emails' : type === 'rejected' ? 'rejectedSuppliers' : 'missedCalls'
    history.push('/tasks/notifications')
    history.push({
      pathname: '/tasks/notifications',
      state: {
        subTab: tmpType
      },
    })
  }

  const searchHandler = () => {
    getNewUnreadNotification(inputText, false, '', active, checkboxInput)
  }

  useEffect(() => {
    // downloadImage(userData.s3FileURL)
  }, [userData.s3FileURL])

  useEffect(() => {
    if (oldUnreadNotification?.length > 0) {
      let allCount = oldUnreadNotification?.length
      let unreadCount = oldUnreadNotification?.filter((notification) => !notification?.isRead)?.length
      setTotal({ all: allCount, unread: unreadCount })
      setHeaderNotification([...oldUnreadNotification])
    } else {
      setHeaderNotification([])
    }
  }, [oldUnreadNotification?.length, active])

  useEffect(() => {
    if (showNotification) {
      getNewUnreadNotification('', false, '', active, checkboxInput)
    }
  }, [showNotification])

  const handleAdminCheckbox = () => {
    setCheckboxInput((prev)=>!prev);
    getNewUnreadNotification('', active === "unread" ? true : false, '', active, !checkboxInput);
  }


  return (
    <>
      <div className={`header-component pe-5 me-3 gap-2 ${isSideMenuExpanded ? 'expanded' : ''}`}>
        <div className={`header-left ${headerLeftClass}`}>
          <div className="search-box input-group d-flex flex-nowrap align-items-center position-relative">
            <input
              type="search"
              id="header-search-form"
              className="form-control shadow-none"
              placeholder='Search'
              onFocus={handleSearchInputClick}
              onChange={handleSearchInput}
              value={searchValue || ''}
              autoComplete='no-search'
            />
            <SearchIcon />
          </div>
        </div>

        <div className="header-right gap-3 mx-4 notification-container-update" >
          <div>
            <div  className='p-3 rounded' style={{ backgroundColor: colors.blue100, cursor: 'pointer' }} onClick={notificationHandler}>
            {
              headerNotificationCount > 0 ? (
                <Badge content={headerNotificationCount}>
                  <BsFillBellFill color={colors.blue400} size={20} onClick={notificationHandler} />
                </Badge>
              ) : <BsFillBellFill color={colors.blue400} size={20} onClick={notificationHandler} />
            }
            </div>

            {showNotification && (
              <div
                className='border px-4 py-3 rounded'
                style={{
                  position: 'absolute',
                  top: 70,
                  right: 65,
                  zIndex: 999,
                  height: 530,
                  width: 500,
                  backgroundColor: 'white',
                }}
              >
                <div className='d-flex justify-content-between align-items-center'>
                  <h3 className='fw-bold m-0'>Notification</h3>
                  {user?.roleName === "admin" ? (
                    <Checkbox
                      onChange={() => handleAdminCheckbox()}
                      checked={checkboxInput}
                    >
                      <h5 className='fw-bold'>Show All Users Notification</h5>
                    </Checkbox>
                  ) : null}
                </div>


                <div className='w-100'>
                  <CustomNav
                    notification={headerNotification}
                    appearance="subtle"
                    active={active}
                    onSelect={handleSelect}
                    total={total}
                    notificationAllCount={notificationAllCount}
                    notificationUnreadCount={notificationUnreadCount}
                  />
                </div>

                <div className='mt-3 d-flex column-gap-3 w-100 align-items-center'>
                  <div className='w-50 position-relative'>
                    <input
                      className="form-control px-3"
                      style={{ height: 35, fontSize: 15 }}
                      value={inputText}
                      onChange={(e) => setInputText(e.target.value)}
                    />
                    {/* <span
                      style={{
                        position: 'absolute',
                        right: 12,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#aaa',
                        pointerEvents: 'none',
                      }}
                    >
                      <i className="bi bi-search fs-5" />
                    </span> */}
                  </div>

                  <div className='w-50 d-flex column-gap-2 align-items-center'>
                    <button
                      className='rounded text-white w-100 fs-4 border-0'
                      style={{ backgroundColor: colors.blue400, height: 35 }}
                      onClick={searchHandler}
                    >
                      Search
                    </button>
                    <button
                      className='rounded text-black w-100 fs-4 border'
                      style={{ backgroundColor: colors.grey200, height: 35 }}
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>

                  <div className="dropdown d-flex align-items-center">
                    <button
                      className="btn btn-secondary dropdown-toggle d-flex align-items-center"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ height: 35, padding: '0 12px' }}
                    >
                      <FaFilter size={15} />
                    </button>

                    <ul className="dropdown-menu p-2" style={{ fontSize: '16px', minWidth: '160px' }}>
                      {filters.map((item) => {
                        return (
                          <li key={item?.value} className='my-2'><button className="dropdown-item" onClick={() => { onFilterCategories(item?.value) }}>{item?.name}</button></li>
                        )
                      })}
                    </ul>
                  </div>
                </div>

                <div className='mt-3 no-scrollbar' style={{ overflowY: 'scroll', height: '67%' }}>
                  <div className='d-flex flex-column row-gap-1'>
                    {headerNotification?.length > 0 ? (
                      headerNotification.map((notification) => (
                        <NotificationMenu
                          key={notification.id}
                          notification={notification}
                          redirectHandler={redirectHandler}
                          setShowNotification={setShowNotification}
                        />
                      ))
                    ) : (
                      <span className='fs-4 text-center mt-5'>No Notifications Yet</span>
                    )}
                  </div>
                </div>

                {headerNotification?.length > 0 && (
                  <div className='my-4'>
                    <Link
                      to={"/tasks/notifications"}
                      className='fs-4'
                      style={{ color: "#214466" }}
                      onClick={() => setShowNotification(false)}
                    >
                      View All
                    </Link>
                  </div>
                )}
              </div>
            )}

          </div>
          <div className="header-right gap-3 mx-4 toggle-account-container" onClick={handleToggleAccount}>
            <div className="account-left">
              <div role="button" className="user-name" >{user['firstname']} {user['lastname']}</div>
              {
                showDropDown && (
                  <div className="account-dropdown">
                    <button type="button" onClick={handleClickSignOut}>Sign Out</button>
                  </div>
                )
              }
            </div>
          </div>
          {!profilePic ? <div className="account-right ms-0" onClick={()=>setShowNotification(false)}></div> : <img className='m-0 me-3 rounded-circle' onClick={()=>setShowNotification(false)} src={profilePic} alt="Fetched from blob" style={{ maxWidth: "30px", marginTop: "30px" }} />}
        </div>
      </div>
      {
        searchModalOpen && (
          <SearchComponent
            searchKeyword={searchValue}
            openModal={searchModalOpen}
            onModalClose={onSearchModalClose}
            filteredData={searchResults}
            recentViewedSearchdData={recentlyVieweSearchdData}
            allSuppliers={searchResults}
            recentKeywords={recentKeywords}
            onRecentKeywordClick={onRecentKeywordClick}
            isLoader={isLoader}
          />
        )
      }

      {/* )} */}
    </>
  )
}

export default HeaderComponent
